import { defineMessages } from 'react-intl';

export const scope = 'app.components.TipDirect.PaymentsTable';

export default defineMessages({
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status'
  },
  type: {
    id: `${scope}.type`,
    defaultMessage: 'Type'
  },
  payment: {
    id: `${scope}.payment`,
    defaultMessage: 'Payment'
  },
  revenue: {
    id: `${scope}.revenue`,
    defaultMessage: 'Amount Tipped'
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Guide Name'
  },
  userId: {
    id: `${scope}.userId`,
    defaultMessage: 'User ID'
  },
  customerName: {
    id: `${scope}.customerName`,
    defaultMessage: 'Customer Name'
  },
  reference: {
    id: `${scope}.reference`,
    defaultMessage: 'Reference'
  },
  activityDate: {
    id: `${scope}.activityDate`,
    defaultMessage: 'Activity Date'
  },
  time: {
    id: `${scope}.time`,
    defaultMessage: 'Time'
  },
  success: {
    id: `${scope}.success`,
    defaultMessage: 'Success'
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: 'Pending'
  },
  failed: {
    id: `${scope}.failed`,
    defaultMessage: 'Failed'
  },
  payments: {
    id: `${scope}.payments`,
    defaultMessage: 'Payments'
  },
  tipType: {
    id: `${scope}.tipType`,
    defaultMessage: 'Tip'
  },
  paymentType: {
    id: `${scope}.paymentType`,
    defaultMessage: 'Payment'
  },
  convertedTip: {
    id: `${scope}.convertedTip`,
    defaultMessage: 'Estimated Payout'
  },
  createPaymentLink: {
    id: `${scope}.createPaymentLink`,
    defaultMessage: 'Create Payment Link'
  },
  commissionType: {
    id: `${scope}.commissionType`,
    defaultMessage: 'Commission'
  },
  viewSwitcherLabel: {
    id: `${scope}.viewSwitcherLabel`,
    defaultMessage: 'Choose which payments to show'
  },
  ownStripeView: {
    id: `${scope}.ownStripeView`,
    defaultMessage: 'My payments'
  },
  companyTransactionsView: {
    id: `${scope}.companyTransactionsView`,
    defaultMessage: 'All guides'
  },
  ownStripeSubtitle: {
    id: `${scope}.ownStripeSubtitle`,
    defaultMessage: 'Track, review and export your transactions.'
  },
  companyTransactionsSubtitle: {
    id: `${scope}.companyTransactionsSubtitle`,
    defaultMessage: 'Every tip collected across your company.'
  }
});
